import { type Currency } from "./types";

export const EUR: Currency = {
  code: "EUR",
  name: "Euro",
  htmlEntity: "&#8364;",
  locale: "en-DE",
  symbol: "€"
};

export const GBP: Currency = {
  code: "GBP",
  name: "British Pound",
  htmlEntity: "&#163;",
  locale: "en-GB",
  symbol: "£"
};

export const INR: Currency = {
  code: "INR",
  name: "Indian Rupee",
  htmlEntity: "&#8377",
  locale: "en-IN",
  symbol: "₹"
};

export const NGN: Currency = {
  code: "NGN",
  name: "Nigerian Naira",
  htmlEntity: "&#8358;",
  locale: "en-US",
  symbol: "₦"
};

export const USD: Currency = {
  code: "USD",
  name: "United States Dollar",
  htmlEntity: "&#36;",
  locale: "en-US",
  symbol: "$"
};
